import { render } from "./ChangePassword.vue?vue&type=template&id=78c76499"
import script from "../js/change-password.js?vue&type=script&lang=js&external"
export * from "../js/change-password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__